/**
 * Ajoute la liste des hébergements dans le local-storage.
 */
const roomSetLastSeenRoomList = ({ roomList }) => {
  // Met à jour le local-storage.
  localStorage.setItem("lastSeenRoomList", JSON.stringify(roomList));
};

export default roomSetLastSeenRoomList;
